import { z } from 'zod';

import { FillColor, HeroCarouselType } from '../models';
import { BasePType } from './base';
import { Breadcrumbs } from './breadcrumbs';
import { CtaButton } from './cta-button';
import { InlineImage } from './inline-image';

export const HeroCarousel = BasePType.extend({
  type: z.enum(['heroCarousel']),
  //
  heroCarouselType: z.nullable(HeroCarouselType),
  textAboveTitle: z.array(z.string()).nullable(),
  richTextTitle: z.array(z.string()),
  description: z.array(z.string()),
  paragraphs: z.array(CtaButton),
  swooshOverlayColor: z.nullable(FillColor),
  //
  translucentImage: z.array(InlineImage),
  carouselImage: z.array(InlineImage),
  //
  overlayAlert1: z.string().nullable().optional(),
  overlayAlert2: z.string().nullable().optional(),
  showContactEmergency: z.boolean().nullable(),
  //
  mobileBreadcrumbs: z.array(Breadcrumbs).nullable(),
});

export type HeroCarousel = z.infer<typeof HeroCarousel>;
